import { bindServices } from '@/services/api';
import { enhanceFormFieldDataWithTypes, toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const api = bindServices('sequence');

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'sequence',

  state: {
    list: [],
    orderBy: '',
    pagination: meta,
    select: 'id,name,pattern',
    expand: {
      process: { select: 'name' },
    },
    notSelectSearch: 'id',
    isConfig: false,
    searchTable: '',
    openView: false,
    selectedItem: {},
    paramsView: {
      select: 'id,name,pattern,created',
      expand: {
        process: { select: 'name' },
        userCreator: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select: 'id,name,pattern',
    },
    view: false,
    openCreateOrEdit: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'sequence/paged',
          params: payload,
        });
        yield put({
          type: 'querySequence',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
            searchTable: payload.search,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *openDrawerView({ payload }, { put }) {
      yield put({
        type: 'openDrawerViewReducer',
        payload,
      });
    },
    *closeDrawerView({ payload }, { put }) {
      yield put({
        type: 'closeDrawerViewReducer',
        payload,
      });
    },
    *fetchItem({ payload }, { call, put }) {
      try {
        const response = yield call(api.getById, {
          route: 'sequence',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'queryItemSequence',
          payload: {
            ...payload,
            item: response,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        const response = yield call(api.apiRoute, {
          route: `sequence/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'deleteSequence',
          payload: response,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },
    *openDrawerCreateOrEdite({ payload }, { put }) {
      yield put({
        type: 'openDrawerCreateOrEditeReducer',
        payload,
      });
    },
    *closeDrawerCreateOrEdit({ payload }, { put }) {
      yield put({
        type: 'closeDrawerCreateOrEditReducer',
        payload,
      });
    },
    *saveAddSequence({ payload }, { call, put }) {
      try {
        yield call(api.create, {
          route: 'sequence',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSequence',
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        yield put({
          type: 'global/showNotificationsForm',
          payload: {
            visible: true,
            type: 'error',
            message: error.message,
            autoHide: true,
          },
          validationErrors: error.validationErrors,
        });
      }
    },
    *saveEditSequence({ payload }, { call, put }) {
      try {
        yield call(api.update, {
          route: 'sequence',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSequence',
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        yield put({
          type: 'global/showNotificationsForm',
          payload: {
            visible: true,
            type: 'error',
            message: error.message,
            autoHide: true,
          },
          validationErrors: error.validationErrors,
        });
      }
    },
  },

  reducers: {
    querySequence(state, { payload }) {
      const dataEnhance = enhanceFormFieldDataWithTypes(payload.items);
      return {
        ...state,
        list: dataEnhance,
        pagination: _.merge(state.pagination, toPaginate(payload)),
        searchTable: payload.searchTable ? payload.searchTable : '',
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        orderBy: '',
      };
    },
    openDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        openView: payload.state,
        selectedItem: {},
        view: true,
      };
    },
    closeDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: null,
        openView: payload.state,
        selectedItem: null,
        view: false,
      };
    },
    queryItemSequence(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        id: payload.id,
      };
    },
    deleteSequence(state) {
      return {
        ...state,
        openView: false,
      };
    },
    openDrawerCreateOrEditeReducer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        openCreateOrEdit: payload.state,
        selectedItem: {},
        status: payload.status,
      };
    },
    closeDrawerCreateOrEditReducer(state, { payload }) {
      return {
        ...state,
        id: null,
        openCreateOrEdit: payload.state,
        selectedItem: null,
      };
    },
    saveSequence(state, { payload }) {
      return {
        ...state,
        openCreateOrEdit: false,
        saveSequence: payload,
        selectedItem: null,
        id: null,
        orderBy: '',
      };
    },
    setPatternInSelectedItem(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.itemValues,
      };
    },
  },
};

export default Model;
